import React, { useState, useEffect } from 'react';
import { Empty, Table, message, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover, Segmented, Skeleton } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { useExcryptedNavigation, ExchangeCurrency } from '../Filters/FilterConditions';
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/DealTable';
import { getAllUsersData, FetchDealByEntity } from "../../../Api/Services/CommonApiService";
import { FetchDealByContact, FetchDealByAccount } from "../../../Api/Services/DealApiService";
import { DealIcon } from '../../../components/Icons/Icons';
import { Cards } from '../../../components/cards/frame/cards-frame'
import AddDealPage from '../Pages/AddCloneDealPage'
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { getAllCustomFieldByCompanyAndEntity } from '../../../Api/Services/CustomeUIApiService';

const { Text } = Typography;
const { Panel } = Collapse;

const DealTable = ({ UrlId, listingType, refreshTrigger, tabKey, listingValues, setSelectedKeys, disabledData, EntityType, queryAction, displayData, NacTrigger, setNaCTrigger }) => {
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'deals')?.customEntityId
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const Role = localData.role
    const dispatch = useDispatch();
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);

        return formattedDate
    }
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    const history = useHistory();
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const [allUsers, setAllUsers] = useState()
    const [deals, setDeals] = useState([])
    const [sortedInfo, setSortedInfo] = useState()
    const [createPage, setCratePage] = useState()
    const [dealTypeData, setDealTypeData] = useState("Active")
    const [dealsList, setDealsList] = useState()
    const [checkboxValues, setCheckboxValues] = useState()
    const dealtype = "DEAL"
    const [openPage, setOpenPage] = useState(Array(dealsList?.length).fill(false));
    const [dataForDeal, setDataForDeal] = useState()
    async function GetExchangeDeal(listingValues) {
        try {
            const SortedData = listingValues.sort((a, b) => b.deals_id - a.deals_id);
            const dataWithCurrency = await Promise.all(
                SortedData.map(async item => {
                    const CurrecnyDealValue = await ExchangeCurrency(Number(item.deal_value), ConvertRate)
                    const CurrecnyGrossDealValue = await ExchangeCurrency(Number(item.gross_deal_value), ConvertRate)
                    const currencyForecast = await ExchangeCurrency(Number(item.forecasted_value), ConvertRate)
                    const currencyProfit = await ExchangeCurrency(Number(item.deal_profit), ConvertRate)
                    const transformedCustomFields = await Promise.all(
                        (item.customFieldValues ?? []).map(async (attr) => {
                            const fieldConfig = checkboxValues.find(field => field.id === attr.fieldId);
                            if (!fieldConfig) return attr;
                            let transformedValue = attr.value;
                            if (fieldConfig.fieldType === "Currency") {
                                const currecnyData = attr.value ? await ExchangeCurrency(Number(attr.value), ConvertRate) : null
                                transformedValue = currecnyData
                                    ? Number(currecnyData?.toFixed(CurencyDecimalPlace))
                                    : 0;
                            } else if (fieldConfig.fieldType === "Date") {
                                transformedValue = attr.value
                                    ? formatDate(attr.value, profile)
                                    : attr.value;
                            }
                            return {
                                ...attr,
                                value: transformedValue,
                            };
                        })
                    );
                    return {
                        ...item,
                        created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
                        modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
                        revenue_start_date: item.revenue_start_date && item.revenue_start_date !== "" ? formatDate(item.revenue_start_date, profile) : "",
                        revenue_end_date: item.revenue_end_date && item.revenue_end_date !== "" ? formatDate(item.revenue_end_date, profile) : "",
                        expected_closure_date: item.expected_closure_date && item.expected_closure_date !== "" ? formatDate(item.expected_closure_date, profile) : "",
                        gross_deal_value: Number(CurrecnyGrossDealValue?.toFixed(CurencyDecimalPlace)),
                        deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                        deal_profit: Number(currencyProfit?.toFixed(CurencyDecimalPlace)),
                        forecasted_value: Number(currencyForecast?.toFixed(CurencyDecimalPlace)),
                        customFieldValues: transformedCustomFields,
                    };
                })
            );
            setDeals(dataWithCurrency)
        } catch (error) {
            message.error(error);
        }
    }
    const createDeal = (Cid, Aid) => {
        setNaCTrigger("trigger")
        setCratePage("ContactPage")
        setDataForDeal({ AccountId: Aid, contactId: [Cid], contactDetails: displayData })
    }
    const createDeal2 = (Aid) => {
        setNaCTrigger("trigger")
        setCratePage("AccountPage")
        setDataForDeal({ AccountId: Aid })
    }
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    async function AllUsersData() {
        try {
            const data = await getAllUsersData();
            setAllUsers(data);
        } catch (error) {
            message.error(error)
        }
    }
    async function AllDeal(type, id) {
        if (type === "Account") {
            try {
                const data = await FetchDealByAccount(id);
                const SortedData = data.sort((a, b) => b.deals_id - a.deals_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        const CurrecnyDealValue = await ExchangeCurrency(Number(item.deal_value), ConvertRate)
                        const currencyForecast = await ExchangeCurrency(Number(item.forecasted_value), ConvertRate)
                        return {
                            ...item,
                            deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                            forecasted_value: Number(currencyForecast?.toFixed(CurencyDecimalPlace)),
                            DataPermission: { isPresent: item.allow },
                        };
                    })
                );
                setDealsList(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (type === "Contact") {
            try {
                const data = await FetchDealByContact(id);
                const SortedData = data.sort((a, b) => b.deals_id - a.deals_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        const CurrecnyDealValue = await ExchangeCurrency(Number(item.deal_value), ConvertRate)
                        const currencyForecast = await ExchangeCurrency(Number(item.forecasted_value), ConvertRate)
                        return {
                            ...item,
                            deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                            forecasted_value: Number(currencyForecast?.toFixed(CurencyDecimalPlace)),
                            DataPermission: { isPresent: item.allow },
                        };
                    })
                );
                setDealsList(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (type === "Task") {
            try {
                const response = await FetchDealByEntity(id, "Deal")
                const SortedData = response.sort((a, b) => b.deals_id - a.deals_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        const CurrecnyDealValue = await ExchangeCurrency(Number(item.deal_value), ConvertRate)
                        const currencyForecast = await ExchangeCurrency(Number(item.forecasted_value), ConvertRate)
                        return {
                            ...item,
                            deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)),
                            forecasted_value: Number(currencyForecast?.toFixed(CurencyDecimalPlace)),
                            DataPermission: { isPresent: item.allow },
                        };
                    })
                );
                setDealsList(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setStates({ ...states, selectedRowKeys, selectedRows });
            setSelectedKeys(selectedRowKeys)
        },
        getCheckboxProps: (record) => {
            const permission = record.SharingData
            const pipelineType = record.PipelineCheck;
            if (record?.DealDataForPermission?.approved_for !== "None") {
                return { disabled: true };
            }
            // Only apply permission checks for these actions
            if (["Update", "OwnerChange", "Delete", "Sharing"].includes(queryAction)) {

                if (queryAction === "Sharing") {
                    return { disabled: record.userId !== profile.userId };
                }
                if (
                    (queryAction === "Update" || queryAction === "OwnerChange") &&
                    (pipelineType === "Won" || pipelineType === "Lost") &&
                    Role !== "Administrator"
                ) {
                    return { disabled: true };
                }

                if (!permission) return { disabled: false }; // Full access if no sharingPermission

                if (["Update", "OwnerChange"].includes(queryAction)) {
                    return { disabled: !permission.includes("Update") };
                }

                if (queryAction === "Delete") {
                    return { disabled: !permission.includes("Delete") };
                }

                 // if (queryAction === "Sharing") {
                //     return { disabled: !permission.includes("Sharing") };
                // }
            }
            return { disabled: false };
        }
    };
    const handleTableChange = async (_, _1, sorter) => {
        setSortedInfo(sorter)
    }
    const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo, defaultCurrency);
    const usersTableData = generateUsersTableData(deals, ViewDetailPage, checkboxValues, defaultCurrency);
    async function getColumnConfig() {
        try {
            const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
            const allFields = [...allFieldsRaw].sort((a, b) => {
                if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
                    return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
                }
                return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
            });
            const structure = allFields.reduce((acc, field) => {
                if (field.fieldVisible === 'No') return acc;
                if (field.fieldKey === "lastName") return acc;
                if (field.fieldType === "FileUpload") return acc;
                if (field.fieldType === "MultiFileUpload") return acc;
                if (field.fieldKey === "firstName") {
                    acc.push({
                        isChecked: true,
                        id: field.fieldId,
                        name: "Name",
                        entityId: field.entityId,
                        fieldKey: "name",
                        fieldType: field.fieldType,
                        dropdownId: field.dropdownId,
                        dropdownType: field.dropdownType,
                        customFieldType: field.customFieldType,
                    });
                    return acc;
                }
                acc.push({
                    isChecked: true,
                    id: field.fieldId,
                    name: field.fieldLabel,
                    entityId: field.entityId,
                    fieldKey: field.fieldKey,
                    fieldType: field.fieldType,
                    dropdownId: field.dropdownId,
                    dropdownType: field.dropdownType,
                    customFieldType: field.customFieldType,
                });
                return acc;
            }, []);
            structure.push(
                {
                    isChecked: true,
                    id: "deal_score",
                    name: "Deal Score",
                    entityId: null,
                    fieldKey: "deal_score",
                    fieldType: "Number",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "created_at",
                    name: "Created Date",
                    entityId: null,
                    fieldKey: "created_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                },
                {
                    isChecked: true,
                    id: "modified_at",
                    name: "Modified Date",
                    entityId: null,
                    fieldKey: "modified_at",
                    fieldType: "Date",
                    dropdownId: null,
                    dropdownType: null,
                    customFieldType: null,
                }
            );
            setCheckboxValues(structure)
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (listingType === "Query") {
            getColumnConfig()
        }
    }, [listingType, listingValues])
    useEffect(() => {
        if (listingType === "Query" && checkboxValues.length) {
            GetExchangeDeal(listingValues)
        }
    }, [checkboxValues])
    useEffect(() => {
        if (listingType !== "Query") {
            if (refreshTrigger === tabKey) {
                AllUsersData()
                if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                    AllDeal("Lead", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                    AllDeal("Deal", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                    AllDeal("Contact", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                    AllDeal("Account", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
                    AllDeal("Task", UrlId[1])
                }
            }
        }
    }, [UrlId, NacTrigger, refreshTrigger, tabKey])
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);

        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }

        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

        // Check if the date is today in the same target timezone
        const today = moment.tz(toTimezone).startOf('day');
        const isToday = converted.isSame(today, 'day');

        if (isToday) {
            return "Today";
        }
        const formattedDate = converted.format("MMM DD, YYYY");
        return formattedDate
    }
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    }; const LoadingCiolums = [
        {
            title: (
                <Skeleton
                    paragraph={{ rows: 1, width: '100%' }}
                    active
                    title={false}
                />
            ),
            dataIndex: 'name',
            key: 'name',
        },]
    return (
        <>
            {listingType === "Query" ?
                // <div className="full-width-table" style={{ width: "100%" }} >
                <div className='Listing-PagePadding' style={{ width: "100%" }}>
                    <Cards headless bodyStyle={{ borderRadius: '10px' }}>
                        <div className="table-bordered leaderboard-table table-responsive">
                            <Table
                                showSorterTooltip={false}
                                rowSelection={rowSelection}
                                dataSource={usersTableData}
                                columns={!deals ? LoadingCiolums : dynamicColumns}
                                locale={{
                                    emptyText: !deals ? (
                                        <TableSkeleton rows={5} />
                                    ) :
                                        deals?.length === 0 && <Empty />
                                }}
                                onChange={handleTableChange}
                                pagination={{
                                    defaultPageSize: 5,
                                    total: usersTableData.length,
                                    showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} items`,
                                }} />
                        </div>
                    </Cards>
                </div>
                :
                <>
                    {UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 15 }}>
                            <div className='Related-Degment'>
                                <Segmented
                                    size='middle'
                                    value={dealTypeData}
                                    options={[
                                        { label: 'Active Deals', value: 'Active' },
                                        { label: 'Won Deals', value: 'Won' },
                                        { label: 'Lost Deals', value: 'Lost' }]}
                                    onChange={value => { setDealTypeData(value) }}
                                /> </div>
                            <div className={disabledData ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                role="button"
                                tabIndex={0} title='Add Deal'
                                onClick={disabledData ? undefined : () => createDeal2(displayData?.account_id)}
                                onKeyDown={(event) => {
                                    if (disabledData && (event.key === 'Enter' || event.key === ' ')) {
                                        createDeal2(displayData?.contacts_id)
                                    }
                                }}
                                aria-label='phone'
                            > <FeatherIcon icon="plus-circle" className="text_iconspace" size={16} />Create Deal</div>
                        </div> : EntityType !== "Task" ?
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginBottom: 15 }}>
                                <div className={disabledData ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                    role="button"
                                    tabIndex={0} title='Add Deal'
                                    onClick={disabledData ? undefined : () => createDeal(displayData?.contacts_id, displayData?.account_id)}
                                    onKeyDown={(event) => {
                                        if (disabledData && (event.key === 'Enter' || event.key === ' ')) {
                                            createDeal(displayData?.contacts_id, displayData?.account_id)
                                        }
                                    }}
                                    aria-label='phone'
                                > <FeatherIcon icon="plus-circle" className="text_iconspace" size={16} />Create Deal</div>
                            </div> : <></>}
                    {dealsList ? (dealsList?.length > 0 ?
                        (() => {
                            const filteredDeals = dealsList.filter(item => {
                                if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                                    if (dealTypeData === "Active") {
                                        return item.pipelineStage !== "Won" && item.pipelineStage !== "Lost";
                                    }
                                    if (dealTypeData === "Won") {
                                        return item.pipelineStage === "Won";
                                    }
                                    if (dealTypeData === "Lost") {
                                        return item.pipelineStage === "Lost";
                                    }
                                }
                                return true;
                            });
                            return filteredDeals.length > 0 ? (
                                filteredDeals.map((item, index) => {
                                    const user = allUsers?.find(user => user.userId === item.deal_owner);
                                    const Name = user ? `${user.firstName} ${user.lastName}` : "Unknown User";
                                    const formattedTimeDifference = convertAndFormatDateTime2(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile)
                                    return (
                                        <div key={index} style={{ marginBottom: 15 }}>
                                            <Card className="DetailsTabCard">
                                                <Collapse bordered={false} className="DetailsTabCollapse">
                                                    <Panel
                                                        header={
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <DealIcon height={16} width={16} marginRight={5} />
                                                                <Text strong style={{ marginRight: 5 }} title={item.deal_name}>{item.deal_name.length > 30 ? `${item.deal_name.slice(0, 30)}...` : item.deal_name}</Text>
                                                                <div className={`task-Tag status-text PipeLine${item.pipeline_stage}`} style={{ marginTop: 1, marginRight: 3 }}>{item.pipelineStage}</div>
                                                                <span style={{ color: "#adb4d2", marginRight: 5 }}>| </span> <span style={{ color: "#adb4d2", fontSize: 12 }}>{Name}</span>
                                                            </div>
                                                        }
                                                        key="1"
                                                        extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}
                                                            </div>
                                                            {item.DataPermission.isPresent &&
                                                                <Popover
                                                                    placement="bottom"
                                                                    content={
                                                                        <div >
                                                                            <div className="text_icon newHover-class"
                                                                                role="button"
                                                                                tabIndex={0} title='View Details'
                                                                                onClick={() => {
                                                                                    ViewDetailPage(item.deals_id, dealtype)
                                                                                    handleOpenPageChange(index)
                                                                                }}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        ViewDetailPage(item.deals_id, dealtype)
                                                                                        handleOpenPageChange(index)
                                                                                    }
                                                                                }}
                                                                                aria-label='view'>
                                                                                <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    trigger="hover"
                                                                    open={openPage[index]}
                                                                    onOpenChange={() => handleOpenPageChange(index)}
                                                                >
                                                                    <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                                </Popover>}
                                                        </div>}
                                                    >
                                                        <Divider style={{ margin: 0 }} />
                                                        <div style={{ marginTop: 10 }}>
                                                            <Text type="secondary">{item.description && item.description !== "" ? <CustomHtmlParser html={item.description} key={index} page="Previewss" /> : "Deal Description"}</Text>
                                                        </div>
                                                        <Divider style={{ margin: "10px 0" }} />
                                                        <Row gutter={16}>
                                                            <Col span={7} style={{
                                                                borderRight: "1px solid #dddddd"
                                                            }}>
                                                                <Text type="secondary" className='RightSide-Lable'>Deal Urgency</Text>
                                                                <br />
                                                                {item.priority_name ? <div className={`table_list_clicks status-text Task${item.priority_name}`}>{item.priority_name}</div> : ""}
                                                            </Col>
                                                            <Col span={7} style={{
                                                                borderRight: "1px solid #dddddd"
                                                            }}>
                                                                <Text type="secondary" className='RightSide-Lable'>Deal Type</Text>
                                                                <br />
                                                                <Text>{item.deal_type_name},</Text><br />
                                                                <Text>{item.subtype}</Text>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Text type="secondary" className='RightSide-Lable'>Deal Value</Text>
                                                                <br />
                                                                <Text>{`${defaultCurrency?.symbol} ${item.deal_value.toLocaleString()}`}</Text>
                                                            </Col>
                                                        </Row>
                                                    </Panel>
                                                </Collapse>
                                            </Card>
                                        </div>
                                    )
                                })) :
                                <div style={{ padding: "10%" }}>
                                    <Empty />
                                </div>
                        })() : (
                            <div style={{ padding: "10%" }}>
                                <Empty />
                            </div>))
                        :
                        <div className="spin">
                            <Spin />
                        </div>
                    }
                </>}
            <AddDealPage UrlId={undefined} FromPage={createPage} setCratePage={setCratePage} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
        </>
    );
}
DealTable.propTypes = {
    queryAction: PropTypes.string.isRequired,
    listingType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    listingValues: PropTypes.array.isRequired,
    setSelectedKeys: PropTypes.func.isRequired,
    disabledData: PropTypes.bool.isRequired,
    displayData: PropTypes.object.isRequired,
    EntityType: PropTypes.string.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(DealTable)